(function () {
  document.documentElement.classList.add('fl-js');

  function reveal() {
    var els = document.querySelectorAll('.fl-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('fl-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (x.isIntersecting) {
          x.target.classList.add('fl-in');
          io.unobserve(x.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  // La barra superior siempre se mueve, aunque el sistema tenga las animaciones reducidas
  function ticker() {
    var track = document.querySelector('.fl-mq-track');
    if (!track || !track.animate) return;
    var running = window.getComputedStyle(track).animationName !== 'none';
    if (running) return;
    track.animate(
      [{ transform: 'translateX(0)' }, { transform: 'translateX(-50%)' }],
      { duration: 28000, iterations: Infinity, easing: 'linear' }
    );
  }

  // Barra fina de progreso al bajar
  function progress() {
    var d = document.createElement('div');
    d.className = 'fl-progress';
    d.setAttribute('aria-hidden', 'true');
    document.body.appendChild(d);
  }

  // Encabezado: sombra y blur al bajar
  function header() {
    var ticking = false;
    function update() {
      document.documentElement.classList.toggle('fl-scrolled', window.scrollY > 12);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  // El numerito del carrito salta cuando cambia
  function cartBump() {
    var last = null;
    function count() {
      var el = document.querySelector('.cart-bubble__text-count');
      return el ? el.textContent.trim() : null;
    }
    last = count();
    new MutationObserver(function () {
      var now = count();
      if (now !== null && now !== last) {
        last = now;
        var b = document.querySelector('.cart-bubble');
        if (b) {
          b.classList.remove('fl-bump');
          void b.offsetWidth;
          b.classList.add('fl-bump');
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // El boton fijo del celular aparece al salir de la portada y se oculta al llegar a los combos
  function sticky() {
    var s = document.querySelector('.fl-sticky');
    var hero = document.querySelector('.fl-hero');
    var combos = document.getElementById('combos');
    if (!s) return;
    if (!hero || !('IntersectionObserver' in window)) { s.classList.add('is-on'); return; }
    var heroOut = false, combosIn = false;
    function update() { s.classList.toggle('is-on', heroOut && !combosIn); }
    new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; update(); }).observe(hero);
    if (combos) new IntersectionObserver(function (e) { combosIn = e[0].isIntersecting; update(); }).observe(combos);
  }

  // Carrito: cambiar la linea actual por un combo de 2 o 3 unidades
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-fl-swap]') : null;
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Cambiando...';
    var to = parseInt(btn.getAttribute('data-fl-to'), 10);
    post('/cart/change.js', { id: btn.getAttribute('data-fl-key'), quantity: 0 })
      .then(function () { return post('/cart/add.js', { id: to, quantity: 1 }); })
      .then(function () { window.location.assign('/cart'); })
      .catch(function () { window.location.assign('/cart'); });
  });

  function init() { reveal(); ticker(); progress(); header(); cartBump(); sticky(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();